(() => {
  const launcher = document.getElementById('E11HalloweenLauncher');
  if (!launcher || launcher.dataset.initialized === 'true') return;
  launcher.dataset.initialized = 'true';
  const formId = launcher.dataset.formId;
  const endsAt = Date.parse(launcher.dataset.endsAt);
  if (!formId || !Number.isFinite(endsAt) || Date.now() >= endsAt) return;
  const keyPrefix = `e11-halloween-2026-${formId}`;
  const submittedKey = `${keyPrefix}-submitted`;
  const closedKey = `${keyPrefix}-closed`;
  const cookieKey = `e11_hw26_${formId}_submitted`;
  const activeForms = new Set();
  const observed = new Set();
  let pending = false;
  let pendingTimeout;
  let frame;
  let expired = false;
  let closed = readStorage('sessionStorage', closedKey) === '1';
  let submitted = launcher.dataset.subscriber === 'true' || wasSubmitted();
  const image = launcher.querySelector('img');
  let imageFailed = Boolean(image.complete && !image.naturalWidth);

  function readStorage(kind, key) {
    try { return window[kind].getItem(key); } catch (_) { return null; }
  }
  function writeStorage(kind, key) {
    try { window[kind].setItem(key, '1'); } catch (_) {}
  }
  function wasSubmitted() {
    if (readStorage('localStorage', submittedKey) === '1' || readStorage('sessionStorage', submittedKey) === '1') return true;
    try { return document.cookie.split(';').some(value => value.trim() === `${cookieKey}=1`); } catch (_) { return false; }
  }
  function persistSubmitted() {
    writeStorage('localStorage', submittedKey);
    writeStorage('sessionStorage', submittedKey);
    try {
      document.cookie = `${cookieKey}=1; Path=/; Expires=${new Date(endsAt).toUTCString()}; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
    } catch (_) {}
  }
  function schedule() {
    if (!frame && !expired) frame = window.requestAnimationFrame(render);
  }
  function isVisible(element) {
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
  }
  function render() {
    frame = 0;
    if (Date.now() >= endsAt) expired = true;
    const viewport = window.visualViewport;
    const viewBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    const viewTop = viewport ? viewport.offsetTop : 0;
    let obstructionTop = viewBottom;
    for (const bar of document.querySelectorAll('.e11-sticky-cart.is-visible[aria-hidden="false"], .e11-sticky-cart.is-visible[aria-hidden="false"] .e11-sticky-message:not(:empty)')) {
      const sticky = bar.matches('.e11-sticky-cart');
      const style = window.getComputedStyle(bar);
      if (style.display === 'none' || style.visibility === 'hidden' || (!sticky && !isVisible(bar))) continue;
      const rect = bar.getBoundingClientRect();
      const top = sticky ? Math.min(rect.top, window.innerHeight - bar.offsetHeight) : rect.top;
      if (rect.width > 0 && rect.height > 0 && rect.bottom > viewTop && top < viewBottom) obstructionTop = Math.min(obstructionTop, top);
    }
    const lift = Math.max(0, window.innerHeight - obstructionTop);
    const offset = `${Math.ceil(lift)}px`;
    if (launcher.style.getPropertyValue('--e11-ghost-obstacle-offset') !== offset) launcher.style.setProperty('--e11-ghost-obstacle-offset', offset);
    const blockedByDialog = Array.from(document.querySelectorAll('dialog[open], cart-drawer.active, details-modal details[open], [aria-modal="true"]')).some(element => element.getAttribute('aria-hidden') !== 'true' && isVisible(element));
    const keyboardOpen = Boolean(viewport && viewport.height < window.innerHeight * 0.7);
    const tooLittleRoom = obstructionTop - viewTop < (window.innerWidth <= 749 ? 124 : 160);
    launcher.hidden = submitted || expired || pending || activeForms.size > 0 || imageFailed || document.hidden || blockedByDialog || keyboardOpen || tooLittleRoom;
    if (expired) {
      window.clearTimeout(pendingTimeout);
      geometryObserver.disconnect();
      discoveryObserver.disconnect();
      resizeObserver?.disconnect();
    }
  }
  const geometryObserver = new MutationObserver(schedule);
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  function observeControls() {
    for (const element of document.querySelectorAll('.e11-sticky-cart, dialog, cart-drawer, details-modal details, [aria-modal="true"]')) {
      if (observed.has(element)) continue;
      observed.add(element);
      geometryObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'open'], childList: true, subtree: element.matches('.e11-sticky-cart'), characterData: element.matches('.e11-sticky-cart') });
      resizeObserver?.observe(element);
    }
    schedule();
  }
  const discoveryObserver = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.e11-sticky-cart, dialog, cart-drawer, details-modal, [aria-modal="true"]') || node.querySelector('.e11-sticky-cart, dialog, cart-drawer, details-modal, [aria-modal="true"]'))))) observeControls();
  });
  discoveryObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    const eventFormId = String(detail.formId || detail.formID || '');
    if (!eventFormId) return;
    if (detail.type === 'open') activeForms.add(eventFormId);
    if (detail.type === 'close' || detail.type === 'redirectedToUrl') activeForms.delete(eventFormId);
    if (eventFormId === formId) {
      if (detail.type === 'open' || detail.type === 'close' || detail.type === 'submit') {
        pending = false;
        window.clearTimeout(pendingTimeout);
      }
      if (detail.type === 'close') {
        closed = true;
        writeStorage('sessionStorage', closedKey);
      }
      if (detail.type === 'submit') {
        submitted = true;
        persistSubmitted();
      }
    }
    schedule();
  });
  launcher.addEventListener('click', () => {
    if (submitted || wasSubmitted() || pending || Date.now() >= endsAt) {
      submitted = submitted || wasSubmitted();
      schedule();
      return;
    }
    pending = true;
    launcher.hidden = true;
    pendingTimeout = window.setTimeout(() => { pending = false; schedule(); }, 15000);
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    } catch (_) {
      pending = false;
      window.clearTimeout(pendingTimeout);
      schedule();
    }
  });
  image.addEventListener('error', () => { imageFailed = true; schedule(); });
  image.addEventListener('load', () => { imageFailed = false; schedule(); });
  window.addEventListener('storage', event => {
    if (event.key === submittedKey && event.newValue === '1') { submitted = true; schedule(); }
  });
  window.addEventListener('pageshow', () => { submitted = submitted || wasSubmitted(); observeControls(); });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('shopify:section:load', observeControls);
  function expireWhenDue() {
    const remaining = endsAt - Date.now();
    if (remaining <= 0) { render(); return; }
    window.setTimeout(expireWhenDue, Math.min(remaining, 2147483647));
  }
  observeControls();
  expireWhenDue();
})();
